module.exports = __webpack_public_path__ + "static/media/enable-boost-core-ssr.47b549eb.png";